import { BtnPrimary, ButtonProps } from '@components/buttons';
import { BrandRow } from 'server/types';
import { autoColor, isLight } from 'shared/colors';

type StyledBrandButtonProps = ButtonProps & {
  brand?: Pick<BrandRow, 'buttonBorderRadius' | 'primaryActionColor'>;
};

/**
 * Button styled according to brand settings
 */
export function StyledBrandButton({ brand, children, ...props }: StyledBrandButtonProps) {
  const combinedClass = `w-full outline-none focus:ring-2 ring-offset-2 py-4 ${props.class || ''}`;
  const outlineColor =
    brand?.primaryActionColor && !isLight(brand.primaryActionColor)
      ? brand.primaryActionColor
      : undefined;

  return (
    <BtnPrimary
      {...props}
      class={combinedClass}
      style={{
        borderRadius: brand?.buttonBorderRadius,
        background: brand?.primaryActionColor,
        color: brand?.primaryActionColor ? autoColor(brand.primaryActionColor) : undefined,
        '--tw-ring-color': outlineColor,
        outlineColor,
      }}
    >
      {children}
    </BtnPrimary>
  );
}
